import { languageCache } from './translationCache.js';

const vueLanguageCache = {
    install(app) {
        app.config.globalProperties.languageCache = languageCache;
    },
};

export default vueLanguageCache;
